import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.scss';

class NameWorkflow extends Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
  };

  componentDidMount() {
    const min = 355,
      max = 100000000,
      pad_right = 5;
    this.input.style.width = min + 'px';
    this.input.onkeypress = this.input.onkeydown = this.input.onkeyup = () => {
      setTimeout(() => {
        var tmp = document.createElement('div');
        tmp.style.padding = '0';
        if (getComputedStyle)
          tmp.style.cssText = getComputedStyle(this.input, null).cssText;
        if (this.input.currentStyle)
          tmp.style.cssText = this.input.currentStyle.cssText;
        tmp.style.width = '';
        tmp.style.position = 'absolute';
        tmp.innerHTML = this.input.value
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;')
          .replace(/ /g, '&nbsp;');
        this.input.parentNode.appendChild(tmp);
        var width = tmp.clientWidth + pad_right + 1;
        tmp.parentNode.removeChild(tmp);
        if (!this.props.value) {
          return (this.input.style.width = 'auto');
        }
        if (0 <= width && width <= max) {
          return (this.input.style.width = width + 'px');
        }
      }, 1);
    };
  }
  render() {
    return (
      <div className="Steps-NameWorkflow">
        <label>Workflow Name</label>
        <div className="row">
          <div className="col-12">
            <input
              type="text"
              className="form-control"
              ref={(elem) => (this.input = elem)}
              placeholder="Enter a name for this workflow"
              autoFocus={true}
              value={this.props.value}
              onChange={this.props.onChange}
              maxLength={150}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default NameWorkflow;
